import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ServicesContext from '@totem/components/context/services/servicesContext';
import { ServiceItem } from '@totem/components/context/services/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { API_V1 } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const ServicesContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loadServices] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [servicesData, setServicesData] = useState<ServiceItem[]>([]);

  useEffect(() => {
    if (loadServices) {
      fetch(`${API_V1}/services`, {
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          if (isNotNull(result)) {
            setServicesData(result);
          }
        })
        .then(() => setIsLoading(false));
    }
  }, [loadServices, getApiToken]);

  return (
    <ServicesContext.Provider
      value={{
        services: servicesData,
        loading: isLoading,
      }}
    >
      {children}
    </ServicesContext.Provider>
  );
};

export default ServicesContainer;
